import { BlackLogo, WhiteLogo } from '@/assets/logos';
import { LogoProps } from '@/data/types';

export type HeaderVariant = 'transparent' | 'light'
export interface HeaderLink { label: string; href?: string }

export const variantStyles: Record<HeaderVariant, string> = {
  transparent: 'text-white',
  light: 'text-[#1B1D2B] bg-white',
}

export const menuIconColor: Record<HeaderVariant, string> = {
  transparent: 'bg-white',
  light: 'bg-[#1B1D2B]',
}

export const logoComponent: Record<HeaderVariant, React.FC<LogoProps>> = {
  transparent: WhiteLogo,
  light: BlackLogo,
}
